var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.2467 6.13317C13.5467 3.05317 10.8601 1.6665 8.50006 1.6665C8.50006 1.6665 8.50006 1.6665 8.4934 1.6665C6.14006 1.6665 3.44673 3.0465 2.74673 6.1265C1.96673 9.5665 4.0734 12.4798 5.98006 14.3132C6.68673 14.9932 7.5934 15.3332 8.50006 15.3332C9.40673 15.3332 10.3134 14.9932 11.0134 14.3132C12.9201 12.4798 15.0267 9.57317 14.2467 6.13317Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50039 9.47344C9.66019 9.47344 10.6004 8.53324 10.6004 7.37344C10.6004 6.21364 9.66019 5.27344 8.50039 5.27344C7.34059 5.27344 6.40039 6.21364 6.40039 7.37344C6.40039 8.53324 7.34059 9.47344 8.50039 9.47344Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dd3efdcdc5bb49e26de6f966de368d61.svg";
export { ForwardRef as ReactComponent };